import { useState } from 'react';

export const useReplyState = () => {
	const [isReplying, setIsReplying] = useState(false);
	const [isReplyReplying, setIsReplyReplying] = useState(false);
	const [isHidden, setIsHidden] = useState(true);

	return {
		isReplying,
		isHidden,
		isReplyReplying,
		toggleReply: () => setIsReplying((prev) => !prev),
		toggleHide: () => setIsHidden((prev) => !prev),
		toggleReplyReplying: () => setIsReplyReplying((prev) => !prev),
	};
};
